import { makeStyles } from '@material-ui/core/styles'

const BRAND_NAVY = '#001C57'
const HUB_CARD_HEADER_BACKGROUND = '#E0EAFF'
const HUB_CARD_HEADER_IMAGE_HEIGHT = 180

const copyBlock = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
}

export const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  discoverLayout: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: theme.spacing(2),
    alignItems: 'stretch',
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'minmax(0, 1.25fr) minmax(0, 1fr)',
    },
  },
  coachCallout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    minHeight: '100%',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  coachCalloutHeaderImage: {
    height: HUB_CARD_HEADER_IMAGE_HEIGHT,
    backgroundColor: HUB_CARD_HEADER_BACKGROUND,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    flexShrink: 0,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      height: 140,
    },
  },
  coachCalloutBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    flex: '1 1 auto',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  coachCalloutTitle: {
    ...copyBlock,
    margin: 0,
    marginBottom: theme.spacing(1),
    fontFamily: '"Source Serif Pro", serif',
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 1.25,
    color: '#00234B',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
  },
  coachCalloutDescription: {
    ...copyBlock,
    margin: 0,
    marginBottom: theme.spacing(2.5),
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#425D69',
  },
  coachCalloutButton: {
    marginTop: 'auto',
    alignSelf: 'flex-start',
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    padding: theme.spacing(1, 2.5),
    boxShadow: 'none',
    maxWidth: '100%',
    '&:hover': {
      boxShadow: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      alignSelf: 'stretch',
    },
  },
  sideStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    minHeight: '100%',
    width: '100%',
    minWidth: 0,
  },
  featureCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: theme.spacing(3),
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    flex: '1 1 auto',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  featureCardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    width: '100%',
    minWidth: 0,
    marginBottom: theme.spacing(1.5),
  },
  featureCardHeading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
    flex: '1 1 auto',
  },
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    color: BRAND_NAVY,
    flexShrink: 0,
    '& svg': {
      fontSize: 20,
    },
  },
  eyebrow: {
    ...copyBlock,
    margin: 0,
    marginBottom: theme.spacing(0.75),
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  cardTitle: {
    ...copyBlock,
    margin: 0,
    fontFamily: '"Source Serif Pro", serif',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.4,
    color: BRAND_NAVY,
  },
  cardDescription: {
    ...copyBlock,
    margin: 0,
    marginBottom: theme.spacing(2),
    flex: '1 1 auto',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#425D69',
  },
  cardLink: {
    marginTop: 'auto',
    alignSelf: 'flex-start',
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    padding: 0,
    minWidth: 0,
    maxWidth: '100%',
    whiteSpace: 'normal',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
    '& .MuiButton-endIcon': {
      marginLeft: theme.spacing(0.5),
      '& svg': {
        fontSize: 16,
      },
    },
  },
}))
